import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';

import Api from '../../lib/seam-api';
import EventCard from './event-card';

import ClipLoader from "react-spinners/ClipLoader";

const NoResults = ({ value = '' }) => {
    return (
        <div className="w-full h-[400px] flex justify-center items-center">
            <div className="flex flex-col gap-[10px] items-center justify-center">
                <img src="/assets/index/no-results.svg" className="h-[150px] mb-4" aria-label="No Results Image"/>
                <h2 class="leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">No results found</h2>
                <p class="mb-4 font-normal text-base text-gray-500 dark:text-gray-400">We couldnt find any matches for <b>{ value }</b></p>
            </div>
        </div>
    )
}

class Events extends Component {
    constructor(props) {
        super(props);

        console.log(this.props.eventTypeId);

        this.state = {
            events: [],
            types: [],
            selectedType: this.props?.eventTypeId?.length !== 0 && this.props?.eventTypeId !== null ? this.props.eventTypeId : null,
            search: '',
            page: 0,
            pageCount: 0,
            itemOffset: 0,
            itemsPerPage: 12,
            cdnUrl : '',
            loading: false,
        }

        this.timer = null;
    }

    componentDidMount() {
        this.fetchDefault();
        this.fetchTypes();
   }

   handlePageClick = (event) => {
    this.setState({ page: event.selected + 1 }, () => this.fetchDefault());
    }

   async fetchDefault() {
        this.setState({ loading: true });

        const { data, meta: { last_page, cdn_url } } = await Api.events().get({
            page: this.state.page,
            perPage: this.state.itemsPerPage,
            eventTypes:this.state.selectedType !== null ? [ Number(this.state.selectedType) ] : []
        });

        this.setState({ events: data, pageCount : last_page, cdnUrl : cdn_url, loading: false });
   }

   async fetchTypes() {
        const { data } = await Api.events().types();

        this.setState({ types: data })
   }

   async search() {
        if (this.state.search.length == 0) return;

        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.searchAll();
   }

   async searchTypes() {
        if (this.state.search.length == 0) return this.fetchDefault();

        this.searchAll();
   }

   async searchAll() {
    this.setState({ loading: true });

    const { data } = await Api.events().search({
        page: this.state.page,
        perPage: this.state.itemsPerPage,
        term: this.state.search,
        eventTypes: this.state.selectedType !== null ? [ Number(this.state.selectedType) ] : []
    });

    this.setState({ events: data, pageCount: 0, loading: false  });
   }

   typesOnChange(event) {
    let value = event.target.value;

    if (value === 'null') value = null;

       this.setState({
           selectedType: value,
       }, () => {
        this.searchTypes();
       });
   }

   onChangeHandler(e) {
        this.setState({
            search: e.target.value,
        }, () => {

            this.changed();
        });
    }

    changed() {
        if (this.state.search.length > 0) {
            return this.search();
        }

        this.fetchDefault();
    }

    getSectionImage(event) {
        if(!event.content) {
            return '';
        }

        if(event.content.hasOwnProperty('sections') === false) {
            return  '';
        }

        const si  =  _.findIndex(event.content.sections, s => {
            return s.name === 'hero';
        });

        if(si === -1) {
            return '';
        }

        const hero = event.content.sections[si];

        if(hero.hasOwnProperty('content') === false) {
            return '';
        }

        return hero.content.hasOwnProperty('background image') ?`${this.state.cdnUrl}/images/${hero.content['background image'].value}`  : '';

    }

    truncateDescription (input) {
        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;
    }

    render () {
        return (
            <section class="bg-white  dark:bg-gray-900 py-8 px-4 mx-auto max-w-screen-xl">
                <div class="flex justify-between w-full gap-4 flex-wrap">
                    <div class="relative w-[400px]">
                        <input type="search"
                               id="Events Search Bar"
                               class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50  md:rounded-l-none border-l-1 md:border-l-6 border border-gray-300"
                               placeholder="Search anything..." required onChange={this.onChangeHandler.bind(this)}
                               value={this.state.search}/>
                        <button type="submit"
                                aria-label="Search Button"
                                className="h-[41.48px] w-[41.48px] flex justify-center items-center absolute top-0 right-0 p-2.5 text-sm font-medium text-white bg-primary-700 rounded-r-lg border border-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                            {this.state.loading ? <ClipLoader
                                color={'white'}
                                loading={true}
                                size={17}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            /> : <svg
                                className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                            </svg>}</button>
                    </div>

                    <div class="flex gap-2">
                        {!this.props?.eventTypeId && <select onChange={this.typesOnChange.bind(this)}
                                                             class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value="null" selected>Event Types</option>
                            {this.state?.types?.map(eventType => <option
                                value={eventType.id}>{eventType.name}</option>)}
                        </select>}
                    </div>

                </div>


                {/* <div id="alert-additional-content-1"  class="p-6 mb-4 mt-6  flex justify-between md:items-center
                  color-primary-700  text-primary-700 flex-col md:flex-row gap-2 bg-blue-50  items-start dark:bg-gray-800" role="alert">
                  <div class={'max-w-[800px]'}>
                      <div class="flex items-center">
                          <svg width={'30px'} height={'30px'} style={{width: '30px', height: '30px'}} className="shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                               fill="currentColor" viewBox="0 0 20 20">
                              <path
                                  d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                          </svg>
                          <span class="sr-only">Info</span>
                          <h3 style={{fontSize : '36px'}} class=" font-primary font-medium uppercase">Parking Disruption Notice</h3>
                      </div>
                      <div class="mt-2 mb-4 text-sm">
                          Please note that the Seam/DMC carpark will be closed for redevelopment until May/June 2026. Please leave ample time prior to your event to find alternative parking.
                      </div>
                  </div>

                    <div class="flex">
                        <a href={'https://enterprisingbarnsley.co.uk/news/parking-notice-aug25'} aria-label={`Read more about ${name}`} role="link"
                           className="w-fit whitespace-nowrap text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            Read More
                            <svg aria-hidden="true" className="w-5 h-5 ml-2 -mr-1" fill="currentColor"
                                 viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                      clip-rule="evenodd"></path>
                            </svg>
                        </a>
                    </div>
                </div> */}


                <div class="py-8 lg:py-16">
                    {this.state.events?.length > 0 ?
                        <div class="grid gap-12 sm:grid-cols-2 sm:gap-16 lg:gap-24 lg:grid-cols-3 xl:grid-cols-3">
                            {this.state?.events?.map(event => <EventCard event={event}
                                                                         getSectionImage={this.getSectionImage.bind(this)}
                                                                         types={this.state.types}/>)}
                        </div> : !this.state.loading && <NoResults value={this.state.search}/>}
                </div>


                {this.state.events?.length > 0 && <div class="flex justify-center w-full">
                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={this.handlePageClick.bind(this)}
                        pageRangeDisplayed={5}
                        pageCount={this.state.pageCount}
                        nextLabel={
                            <>
                                <span class="sr-only">Previous</span>
                                <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clip-rule="evenodd"></path>
                                </svg>
                            </>
                        }
                        previousLabel={
                            <>
                                <span class="sr-only">Next</span>
                                <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                          clip-rule="evenodd"></path>
                                </svg>
                            </>
                        }
                        renderOnZeroPageCount={null}
                        containerClassName="pagination"
                    />
                </div>}

            </section>
        )
    }
}

export default Events;

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('events')

    if (element) {
        ReactDOM.render(<Events eventTypeId={element.getAttribute('eventTypeId')}/>, element);
    }
});
